var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseComponent',{attrs:{"isReady":_vm.isReady}},[_c('ContentLoader',{attrs:{"slot":"loader"},slot:"loader"}),_c('div',{staticClass:"home"},[(_vm.config)?_c('TNC',{attrs:{"config":_vm.config}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }